/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  BloodSacrifice,
  BloodSacrificeInterface,
} from "../BloodSacrifice";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "forwarderAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "bloodAddress",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "who",
        type: "address",
      },
      {
        indexed: false,
        internalType: "enum Cult",
        name: "cult",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "BloodSacrificed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [],
    name: "getCultStats",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "forwarder",
        type: "address",
      },
    ],
    name: "isTrustedForwarder",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "enum Cult",
        name: "cult",
        type: "uint8",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "sacrifice",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "sacrificesByAddress",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "enum Cult",
        name: "",
        type: "uint8",
      },
    ],
    name: "sacrificesForCult",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "trustedForwarder_",
        type: "address",
      },
    ],
    name: "setForwarder",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "versionRecipient",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
];

const _bytecode =
  "0x608060405234801561001057600080fd5b5060405161094738038061094783398101604081905261002f9161011f565b8161004061003b610075565b6100af565b600180546001600160a01b039283166001600160a01b0319918216179091556002805493909216921691909117905550610152565b6001546000906001600160a01b0316331415610098575060131936013560601c90565b6100aa6100ff60201b6105971760201c565b905090565b600080546001600160a01b038381166001600160a01b0319831681178455604051919092169283917f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e09190a35050565b3390565b80516001600160a01b038116811461011a57600080fd5b919050565b6000806040838503121561013257600080fd5b61013b83610103565b915061014960208401610103565b90509250929050565b6107e6806101616000396000f3fe608060405234801561001057600080fd5b506004361061009e5760003560e01c8063715018a611610066578063715018a6146101605780638da5cb5b14610168578063b9998a2414610183578063d821ec2814610196578063f2fde38b1461022857600080fd5b8063198527a4146100a3578063295c3147146100d6578063486ff0cd146100eb578063572b6c051461010e5780636d2ca63714610140575b600080fd5b6100c36100b1366004610679565b60036020526000908152604090205481565b6040519081526020015b60405180910390f35b6100e96100e4366004610694565b61023b565b005b60408051808201825260018152603160f81b602082015290516100cd91906106ea565b61013061011c366004610627565b6001546001600160a01b0391821691161490565b60405190151581526020016100cd565b6100c361014e366004610627565b60046020526000908152604090205481565b6100e9610414565b6000546040516001600160a01b0390911681526020016100cd565b6100e9610191366004610627565b610472565b600360208190527fa15bc60c955c405d20d9149c709e2460f1c2d9a497496a7f46004d1772c3054c547fc3a24b0501bd2c13a7e57f2db4369ec4c223447539fc0724a9d55ac4a06ebd4d5460009283527fcbc4e5fb02c3d1de23a9f1e014b4d2ee5aeaea9505df5e855c9210bf472495af546040805194855260208501939093529183015260608201526080016100cd565b6100e9610236366004610627565b6104dd565b6002546001600160a01b03166323b872dd61025461059b565b6040516001600160e01b031960e084901b1681526001600160a01b03909116600482015230602482015260448101849052606401602060405180830381600087803b1580156102a257600080fd5b505af11580156102b6573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906102da9190610657565b50600254604051630852cd8d60e31b8152600481018390526001600160a01b03909116906342966c6890602401600060405180830381600087803b15801561032157600080fd5b505af1158015610335573d6000803e3d6000fd5b5050505080600360008460048111156103505761035061079a565b60048111156103615761036161079a565b8152602001908152602001600020600082825461037e9190610774565b909155508190506004600061039161059b565b6001600160a01b03166001600160a01b0316815260200190815260200160002060008282546103c09190610774565b909155506103ce905061059b565b6001600160a01b03167ff48a6b61acd5f1f2d19c0c46a6462fee5fdc9ee23a5ee991edfa068397ae97a783836040516104089291906106be565b60405180910390a25050565b61041c61059b565b6001600160a01b03166104376000546001600160a01b031690565b6001600160a01b0316146104665760405162461bcd60e51b815260040161045d9061073f565b60405180910390fd5b61047060006105c3565b565b61047a61059b565b6001600160a01b03166104956000546001600160a01b031690565b6001600160a01b0316146104bb5760405162461bcd60e51b815260040161045d9061073f565b600180546001600160a01b0319166001600160a01b0392909216919091179055565b6104e561059b565b6001600160a01b03166105006000546001600160a01b031690565b6001600160a01b0316146105265760405162461bcd60e51b815260040161045d9061073f565b6001600160a01b03811661058b5760405162461bcd60e51b815260206004820152602660248201527f4f776e61626c653a206e6577206f776e657220697320746865207a65726f206160448201526564647265737360d01b606482015260840161045d565b610594816105c3565b50565b3390565b6001546000906001600160a01b03163314156105be575060131936013560601c90565b503390565b600080546001600160a01b038381166001600160a01b0319831681178455604051919092169283917f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e09190a35050565b80356005811061062257600080fd5b919050565b60006020828403121561063957600080fd5b81356001600160a01b038116811461065057600080fd5b9392505050565b60006020828403121561066957600080fd5b8151801515811461065057600080fd5b60006020828403121561068b57600080fd5b61065082610613565b600080604083850312156106a757600080fd5b6106b083610613565b946020939093013593505050565b60408101600584106106e057634e487b7160e01b600052602160045260246000fd5b9281526020015290565b600060208083528351808285015260005b81811015610717578581018301518582016040015282016106fb565b81811115610729576000604083870101525b50601f01601f1916929092016040019392505050565b6020808252818101527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e6572604082015260600190565b6000821982111561079557634e487b7160e01b600052601160045260246000fd5b500190565b634e487b7160e01b600052602160045260246000fdfea2646970667358221220d23c833bc44ad17f100134c1b08677fc1a16b0925c39ac58130765ec67be9e6464736f6c63430008070033";

type BloodSacrificeConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: BloodSacrificeConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class BloodSacrifice__factory extends ContractFactory {
  constructor(...args: BloodSacrificeConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "BloodSacrifice";
  }

  override deploy(
    forwarderAddress: string,
    bloodAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<BloodSacrifice> {
    return super.deploy(
      forwarderAddress,
      bloodAddress,
      overrides || {}
    ) as Promise<BloodSacrifice>;
  }
  override getDeployTransaction(
    forwarderAddress: string,
    bloodAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      forwarderAddress,
      bloodAddress,
      overrides || {}
    );
  }
  override attach(address: string): BloodSacrifice {
    return super.attach(address) as BloodSacrifice;
  }
  override connect(signer: Signer): BloodSacrifice__factory {
    return super.connect(signer) as BloodSacrifice__factory;
  }
  static readonly contractName: "BloodSacrifice";

  public readonly contractName: "BloodSacrifice";

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): BloodSacrificeInterface {
    return new utils.Interface(_abi) as BloodSacrificeInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): BloodSacrifice {
    return new Contract(address, _abi, signerOrProvider) as BloodSacrifice;
  }
}
